module.exports = __webpack_public_path__ + "static/media/workday.37a8de08.svg";